/**
 * @func 环境信息
 * @param {String}   NODE_ENV             环境变量
 * @param {String}   baseURL              请求基本路径，常设置为域名
 * @param {String}   appKey               麦芽平台appkey，用于暗水印服务
 * @param {String}   apmKey               听云-悟空，APM监控平台应用识别Key
 * @param {Boolean}  apmDebug             true-数据进入听云测试环境   false-数据进入正式环境
 * @param {String}   satisfactionAppkey   满意度应用识别Key
 * @param {Boolean}  satisfactionAppDebug 满意度Debug开关
 * @param {String}   itsmKey              ITSM报事系统Key
 * @param {String}   itsmServer           ITSM报事服务地址
 */

const config = {
	sit: {
		NODE_ENV: 'sit',
		baseURL: 'https://iwork-sit.longfor.com',
		contactsAvatarURL: 'https://yts-oss-static-uat.oss-cn-beijing.aliyuncs.com/original-nas-uat/headImg/small/',
		desktopUrl: 'longfortest://',
		fileTransferRobotId: 'jMKhZUtrFQ1rXlHjggnTc8U' // 文件小助手 id
	},
	uat: {
		NODE_ENV: 'uat',
		baseURL: 'https://iwork-uat.longfor.com',
		contactsAvatarURL: 'https://yts-oss-static-uat.oss-cn-beijing.aliyuncs.com/original-nas-uat/headImg/small/',
		desktopUrl: 'longforuat://',
		fileTransferRobotId: 'jMKhZUtrFQ1rXlHjggnTc8U' // 文件小助手 id
	},
	pre: {
		NODE_ENV: 'pre',
		baseURL: 'https://pwb-pre.longfor.com',
		contactsAvatarURL: 'https://prod-longxin-oss.oss-cn-beijing.aliyuncs.com/original-nas-pre/headImg/small/',
		desktopUrl: 'longforpre://',
		fileTransferRobotId: 'jMKhZUtrFQ1rXlHjggnTc8U' // 文件小助手 id
	},
	prod: {
		NODE_ENV: 'prod',
		baseURL: 'https://iwork.longfor.com',
		contactsAvatarURL: 'https://prod-longxin-oss.oss-cn-beijing.aliyuncs.com/original-nas-pro/headImg/small/',
		desktopUrl: 'longfor://',
		fileTransferRobotId: '9clYIu83IeTA4rROiUwGGcM' // 文件小助手 id
	},
	common: {
		systemNo: 'YTS',
		systemName: '云图梭-协同门户'
	}
}
const configer = {}
if (process.env.NODE_ENV === 'development') {
	Object.assign(configer, config.common, config.uat)
} else {
	Object.assign(configer, config.common, config[process.env.VUE_APP_CURRENTMODE])
}
// if (window.location.origin.indexOf('sit') >= 0) {
// 	Object.assign(configer, config.common, config.sit)
// } else if (window.location.origin.indexOf('uat') >= 0) {
// 	Object.assign(configer, config.common, config.uat)
// } else if (window.location.origin.toLowerCase().indexOf('pre') >= 0) {
// 	Object.assign(configer, config.common, config.pre)
// } else if (
// 	window.location.origin.indexOf('iwork.longfor.com') >= 0 ||
// 	window.location.origin.indexOf('iwork.longhu.net') >= 0
// ) {
// 	Object.assign(configer, config.common, config.prod)
// } else {
// 	Object.assign(configer, config.common, config.prod)
// }

export { configer }
